import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";

const theme = createTheme();

const useGateTestStyles = makeStyles(() => ({
  rootContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
      "@supports (height: 100dvh)": {
      height: "100dvh",
    },
    width: "100%",
    overflowX: "hidden",
  },
  headerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "right",
  },
  mainContainer: {
    flex: 1,
    display: "flex",
    overflow: "hidden",
  },
  contentContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
  },
  questionContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    width: "100%",
    overflowX: "hidden",
    overflowY: "auto",
  },
  // Wrapper that holds both the pull-tab toggle and the sidebar panel
  sidebarWrapper: {
    display: "flex",
    flexDirection: "row",
    position: "relative",
    flexShrink: 0,
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  // The pull-tab: always visible, sticks to the left edge of sidebarWrapper
  toggleBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "black",
    padding: "15px 0px",
    cursor: "pointer",
    borderRadius: "4px 0 0 4px",
    width: "15px",
    alignSelf: "center",
    flexShrink: 0,
  },
  sidebarContainer: {
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "0px",
    },
  },
  mobileDrawer: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "block",
    },
    "& .MuiDrawer-paper": {
      width: "300px",
    },
  },
  menuButton: {
    marginRight: 0,
  },
  img: {
    "& img": {
      maxWidth: "100% !important",
      width: "auto !important",
      height: "auto !important",
      verticalAlign: "middle",
      display: "inline-block",
      "@media (max-width:599px)": {
        maxWidth: "100% !important",
        width: "auto !important",
      }
    },
  },
}));

export default useGateTestStyles;
